<template>
  <div class="vmp-alert-wrap" v-show="visible">
    <div class="popup">
      <div class="recordboxHeader">
        <span class="header-title">{{ title || $t('account.account_1061') }}</span>
        <a
          href="javascript:;"
          @click="onClose"
          class="vh-iconfont vh-line-close"
          v-if="isShowClose"
        ></a>
      </div>
      <div class="popbody">
        <p class="f-12 tips">
          <slot name="content"></slot>
        </p>
        <p class="btnsbox" v-if="confirm">
          <vh-button plain round type="info" class="cancel" v-if="cancelText" @click="onCancel">
            {{ cancelText || $t('other.other_1028') }}
          </vh-button>
          <vh-button type="primary" round class="confirm" @click="onSubmit">
            {{ confirmText || $t('other.other_1027') }}
          </vh-button>
        </p>
        <p class="btnsbox" v-else-if="retry">
          <vh-button type="primary" round class="confirm" @click="onSubmit">
            {{ retry || $t('host.k_611007') }}
          </vh-button>
        </p>
        <p class="btnsbox" v-else>
          <vh-button type="primary" round class="confirm" @click="onClose">
            {{ knowText || $t('other.other_1019') }}
          </vh-button>
        </p>
        <vh-tooltip class="item" effect="dark" placement="bottom-end">
          <div class="tooltip-content" slot="content">
            <p class="content-title">{{ $t('host.k_659001') }}</p>
            <p>{{ $t('host.k_659002') }}</p>
            <p>{{ $t('host.k_659003') }}</p>
            <p>{{ $t('host.k_659004') }}</p>
            <p>{{ $t('host.k_659005') }}</p>
            <p>{{ $t('host.k_659006') }}</p>
            <p>{{ $t('host.k_659007') }}</p>
          </div>
          <span class="qaTip" v-if="showQA">{{ $t('host.k_659008') }}</span>
        </vh-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'popup',
    props: {
      visible: {
        type: Boolean
      },
      title: {
        required: false
      },
      confirm: {
        required: false
      },
      knowText: {
        required: false
      },
      retry: {
        required: false
      },
      confirmText: {
        required: false
      },
      cancelText: {
        required: false
      },
      isShowClose: {
        type: Boolean,
        default: true
      },
      showQA: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClose() {
        this.$emit('onClose');
      },
      onCancel() {
        this.$emit('onCancel');
      },
      onSubmit() {
        this.$emit('onSubmit');
      }
    }
  };
</script>
<style lang="less" scoped>
  .vmp-alert-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1200;
    align-items: center;
    display: flex;
    justify-content: center;
    * {
      box-sizing: border-box;
    }
    .popup {
      width: 400px;
      min-height: 200px;
      box-shadow: 0px 12px 42px 0px rgba(51, 51, 51, 0.24);
      border-radius: 4px;
      background-color: #fff;
      position: relative;
      margin-top: -10%;
      display: flex;
      flex-direction: column;

      .recordboxHeader {
        position: relative;
        padding: 24px 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          color: #666;
        }
        .header-title {
          font-size: 20px;
          font-weight: 500;
          color: #1a1a1a;
        }
        .iconguanbi1 {
          position: absolute;
          top: 28px;
          color: #666;
          font-size: 12px;
          right: 32px;
        }
      }
      .popbody {
        flex: 1;
        position: relative;
        font-size: 12px;
        line-height: 2;
        padding-top: 0px;
        padding-bottom: 25px;
        padding: 0 32px;
        display: flex;
        flex-direction: column;

        .tips {
          font-size: 14px;
          line-height: 20px;
          color: #1a1a1a;
          flex: 1;
          padding-bottom: 20px;
        }
        .content {
          margin: 10px auto 24px;
          text-align: center;
        }
        .btnsbox {
          display: block;
          position: relative;
          text-align: right;
          margin-bottom: 20px;

          .vh-button {
            &.confirm {
              // background: var(--theme-color-main);
              // color: #ffffff;
            }
            &.cancel {
              // margin-right: 12px;
              &:hover {
                // border-color: var(--theme-color-main);
              }
            }
          }
        }
        .qaTip {
          position: absolute;
          bottom: 24px;
          left: 32px;
          font-size: 14px;
          cursor: pointer;
          &:hover {
            color: #0a7ff5;
          }
        }
      }
    }
  }
  .vmp-dialog-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1200;
    align-items: center;
    display: flex;
    justify-content: center;
    * {
      box-sizing: border-box;
    }
  }
</style>
<style lang="less">
  .vh-popper .popper__arrow::after {
    border-bottom-color: #fff !important;
  }
  .vh-tooltip__popper .tooltip-content {
    line-height: 24px;
    .content-title {
      font-weight: bold;
    }
  }
</style>
